<app-loading-spinner *ngIf="loadingSpinnerService.loading$ | async">
</app-loading-spinner>

<div class="login-wrapper">
  <div class="login-left" *ngIf="!isAdmin || isOrdersAdmin">
    <!-- Regular User Login Form -->
    <form (ngSubmit)="login()">
      <img src="../../assets/images/logo.svg" alt="" />
      <h1>Log in</h1>
      <h4>Enter your credentials</h4>
      <div class="form-group">
        <label for="exampleInputEmail1">Email address</label>
        <input
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          [(ngModel)]="email"
          name="email"
          placeholder="ex. example@mail.com"
        />
      </div>

      <div class="form-group position-relative">
        <label for="exampleInputPassword1">Password</label>
        <input
          [type]="passwordFieldType"
          class="form-control"
          id="exampleInputPassword1"
          [(ngModel)]="password"
          name="password"
          placeholder="**************"
        />
        <img
          class="eye-icon"
          src="{{
            passwordFieldType === 'password'
              ? 'assets/images/closed-eye.svg'
              : 'assets/images/open-eye.svg'
          }}"
          (click)="togglePasswordVisibility()"
          alt="Toggle visibility"
        />
      </div>

      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          id="rememberMe"
          [(ngModel)]="rememberMe"
          name="rememberMe"
        />
        <label class="form-check-label" for="rememberMe">Remember me</label>
      </div>

      <button type="submit" class="btn btn-primary">Log in</button>
    </form>
    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger mt-3">
      {{ errorMessage }}
    </div>
  </div>

  <!-- Super Admin Business Selection -->
<div *ngIf="isAdmin && !isOrdersAdmin" class="playgrounds-wrapper">
  <div class="d-flex  align-items-center mb-3">
    <h1>Select Playground</h1>
    <input 
      type="text"
      placeholder="Search for Playground"
      class="form-control w-50"
      (input)="searchBusinesses($event)" />
  </div>

  <div class="d-flex  flex-wrap">
    <div 
      *ngFor="let business of filteredBusinesses" 
      class="playground-card"
      [class.playground-card-no-image]="userRole === 'ordersAdmin'"
      (click)="userRole === 'ordersAdmin' ? onOrdersAdminSelectPlayground(business) : superAdminLoginToBusiness(business.id)">
      <div *ngIf="userRole !== 'ordersAdmin'" class="playground-card-image-wrap">
        <img
          [src]="business.businessImageUrl"
          alt="{{ business.name }}"
          class="img-fluid"
        />
      </div>
      <div *ngIf="userRole === 'ordersAdmin'" class="playground-card-placeholder">
        <img src="../../assets/images/confetti.svg" alt="" class="playground-card-icon" />
      </div>
      <h3>{{ business.name }}</h3>
    </div>
  </div>
</div>

</div>

